'use strict';

angular.module('membership')
  .controller('SearchCtrl', [
    '$scope', 'SearchViewModel', 'magAssistConfigService',
    function ($scope, viewModel, magAssistConfigService) {
      $scope.magAssistConfig = magAssistConfigService;
      $scope.model = new viewModel();
      magAssistConfigService.init().then(function () {
        if (!magAssistConfigService.hideCustomerScreens && $scope.model.selectedType === 'users') {
          $scope.model.selectedType = 'customers';
        }
      }).catch(angular.noop);
    }
  ]);
